import DEFAULT_CATEGORIES from "../data/default-categories.json";

type Props = { products: Product[]; category?: Category; productsExisted: boolean };
export const C411Widget = ({ category, products, productsExisted }: Props) => {
  return (
    <div className='c411-widget'>
      <h3 className='c411-widget-title'>
        Mercheo {productsExisted ? category?.name : ''} Picks
      </h3>
      {productsExisted ? <ProductList category={category as Category} products={products} /> : <CategorySelection category={category} />}
    </div>
  );
};

const CategorySelection = ({ category }: { category?: Category }) => (
  <div className='product-categories'>
    <ul>
      {
        DEFAULT_CATEGORIES.map((defaultCategory) => (
          <li
            key={defaultCategory.name}
            className={category?.name?.toLowerCase() === defaultCategory.name ? 'active-category' : ''}
          >
            <a href={`/?category=${defaultCategory.name}&q=${defaultCategory.name}`}>{defaultCategory.label}</a>
          </li>
        ))
      }
    </ul>
  </div>
);

type ProductListProps = { products: Product[]; category: Category; };
const ProductList = ({ category, products }: ProductListProps) => (
  <ul className='products-list'>
    {
      products.map((product) => (
        <li key={product.id} className='product-list-item'>
          <a target='_blank' href={product.landingPageUrl} rel="noreferrer">
            <div className='product-list-description'>
              <span>{product.company.name}</span>
              <div className='stars-wrapper mobile-only'>
                {
                  product.solidStar.map((item) => (
                    <svg key={item} xmlns='http://www.w3.org/2000/svg'
                      className='icon-star'
                      viewBox='0 0 20 20' fill='currentColor'>
                      <path
                        d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                    </svg>
                  ))
                }
                {
                  product.outlinedStar.map((item) => (
                    <svg key={item} xmlns="http://www.w3.org/2000/svg"
                      className="icon-star-outlined" fill="none"
                      viewBox="0 0 24 24" stroke="currentColor"
                      strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round"
                        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>
                  ))
                }
              </div>
            </div>

            <div className='stars-wrapper desktop-only'>
              {
                product.solidStar.map((item) => (
                  <svg key={item} xmlns='http://www.w3.org/2000/svg'
                    className='icon-star'
                    viewBox='0 0 20 20' fill='currentColor'>
                    <path
                      d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z' />
                  </svg>
                ))
              }
              {
                product.outlinedStar.map((item) => (
                  <svg key={item} xmlns="http://www.w3.org/2000/svg"
                    className="icon-star-outlined" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor"
                    strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round"
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                  </svg>
                ))
              }
            </div>

            <div className='product-list-item-cta-wrapper'>
              <button type='button' className='product-list-item-cta'>
                <span>Get Quote</span>
                <div className='icon-wrapper'>
                  <svg xmlns='http://www.w3.org/2000/svg'
                    className='icon-external-link' fill='none'
                    viewBox='0 0 24 24' stroke='currentColor'
                    strokeWidth='2'>
                    <path strokeLinecap='round' strokeLinejoin='round'
                      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14' />
                  </svg>
                </div>
              </button>
            </div>
          </a>
        </li>
      ))
    }
    <li className='product-list-item widget-cta'>
      <a href={`https://www.comparison411.com/${category.slug}/rankings`} target='_blank' rel="noreferrer">
        <p>
          Click here to See Our Full Reviews
        </p>
        <svg xmlns="http://www.w3.org/2000/svg" className="icon-right" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round"
            d="M13 5l7 7-7 7M5 5l7 7-7 7" />
        </svg>
      </a>
    </li>
  </ul>
);
